
/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
};

//Home Page
const greeting = {
  title: "Hi",
  title2: " I'm Kabeer Ahmed",
  logo_name: "Kabeer Ahmed",
  // nickname: "harry / picleric",
  full_name: "Kabeer Ahmed",
  subTitle1: "Software Engineer.",
  subTitle2: "MERN Stack Developer.",
  subTitle: "Full Stack Developer, Life Long Learner.",
  resumeLink:
    "https://drive.google.com/file/d/1Wj7D9KHBETQNhvfvZJeZVoeslspfhWUL/view?usp=sharing",
  mail: "kabeerahmed.dev@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/kabeer-ka-ahmed",
  linkedin: "https://www.linkedin.com/in/kabeer--ahmed",
  gmail: "kabeerahmed.dev@gmail.com",
  // twitter: "https://twitter.com/sumitsharma002",
};

const skills = {
  data: [
    {
      _id: "354c54b7-ffd8-40f1-972f-1d006733df25",
      title: "MERN Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive user interfaces and backend for web applications",
        "⚡ Building responsive website front end using React with Material UI, Tailwind CSS or Bootstrap",
        "⚡ Creating application backend in Node, Express, MongoDB and Rest API",
        "⚡ Integration of third party services such as Stripe, Cloudways, Vercel etc.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#0769ad",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        // {
        //   skillName: "Redux",
        //   fontAwesomeClassname: "simple-icons:redux",
        //   style: {
        //     color: "#593D88",
        //   },
        // },
        // {
        //   skillName: "Angular",
        //   fontAwesomeClassname: "simple-icons:angular",
        //   style: {
        //     color: "#dd0031",
        //   },
        // },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "logos:nodejs",
          style: {
            color: "#339933",
          },
        },
        // {
        //   skillName: "NestJs",
        //   fontAwesomeClassname: "logos:nestjs",
        //   style: {
        //     color: "#339933",
        //   },
        // },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "gray",
          },
        },
        {
          skillName: "Material UI",
          fontAwesomeClassname: "simple-icons:uikit",
          style: {
            color: "#007FFF",
          },
        },
        {
          skillName: "Tailwind CSS",
          fontAwesomeClassname: "logos:tailwindcss-icon",
          style: {
            color: "#635BFF",
            width: "1em",
            height: "1em",
          },
        },
        // {
        //   skillName: "Framer Motion",
        //   fontAwesomeClassname: "logos:framer",
        //   style: {
        //     color: "#635BFF",
        //     width: "1em",
        //     height: "1em",
        //   },
        // },
        // {
        //   skillName: "Styled Components",
        //   fontAwesomeClassname: "vscode-icons:file-type-styled",
        //   style: {
        //     color: "#635BFF",
        //     width: "1em",
        //     height: "1em",
        //   },
        // },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563d7c",
          },
        },

        // {
        //   skillName: "NPM",
        //   fontAwesomeClassname: "simple-icons:npm",
        //   style: {
        //     color: "#CB3837",
        //   },
        // },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        // {
        //   skillName: "Cloudinary",
        //   fontAwesomeClassname: "logos:cloudinary-icon",
        //   style: {
        //     color: "#635BFF",
        //     width: "1em",
        //     height: "1em",
        //   },
        // },

        // {
        //   skillName: "Java",
        //   fontAwesomeClassname: "simple-icons:java",
        //   style: {
        //     color: "#f89820",
        //   },
        // },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        // {
        //   skillName: "PostgreSQL",
        //   fontAwesomeClassname: "simple-icons:postgresql",
        //   style: {
        //     color: "#4479A1",
        //   },
        // },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FF6C37",
          },
        },
        {
          skillName: "Stripe",
          fontAwesomeClassname: "logos:stripe",
          style: {
            color: "#635BFF",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        // {
        //   skillName: "C++",
        //   fontAwesomeClassname: "simple-icons:cplusplus",
        //   style: {
        //     color: "#E94E32",
        //   },
        // },
        // {
        //   skillName: "Python",
        //   fontAwesomeClassname: "simple-icons:python",
        //   style: {
        //     color: "#3776AB",
        //   },
        // },
      ],
    },
    {
      _id: "c026fe64-1542-42b0-84ab-9311840c169f",
      title: "Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "Google Cloud Platform",
          fontAwesomeClassname: "skill-icons:gcp-dark",
          style: {
            backgroundColor: "transparent",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Vercel",
          fontAwesomeClassname: "skill-icons:vercel-light",
          style: {
            color: "gray",
            fill: "gray",
            // backgroundColor: "white",
            width: "1em",
            height: "1em",
          },
        },
        // {
        //   skillName: "Netlify",
        //   fontAwesomeClassname: "simple-icons:netlify",
        //   style: {
        //     color: "#38AFBB",
        //     width: "1em",
        //     height: "1em",
        //   },
        // },
        // {
        //   skillName: "Heroku",
        //   fontAwesomeClassname: "simple-icons:heroku",
        //   style: {
        //     color: "#6863A6",
        //     width: "1em",
        //     height: "1em",
        //   },
        // },
        // {
        //   skillName: "Firebase",
        //   fontAwesomeClassname: "simple-icons:firebase",
        //   style: {
        //     color: "#FFCA28",
        //     width: "1em",
        //     height: "1em",
        //   },
        // },
        // {
        //   skillName: "PostgreSQL",
        //   fontAwesomeClassname: "simple-icons:postgresql",
        //   style: {
        //     color: "#336791",
        //     width: "1em",
        //     height: "1em",
        //   },
        // },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
            width: "1em",
            height: "1em",
          },
        },
        // {
        //   skillName: "Docker",
        //   fontAwesomeClassname: "simple-icons:docker",
        //   style: {
        //     color: "#1488C6",
        //   },
        // },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
            width: "1em",
            height: "1em",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Gujrat, Gujrat",
      subtitle: "Masters in Computer Science (MSC CS)",
      logo_path: "uog-logo.png",
      alt_name: "UOG",
      duration: "2020 - 2022",
      descriptions: [
        "⚡ I have taken varity of courses related to Artificial Intelligence, Machine Learning, Computer Programming etc.",
        "⚡ Apart from this, I have done courses on Cloud Computing, Data Sciences and MERN Stack Development.",
      ],
      website_link: "https://uog.edu.pk/main.php",
    },
    {
      title: "University of the Punjab, Lahore",
      subtitle: "Bachelors in Computer Science (BSC CS)",
      logo_path: "pu-logo.png",
      alt_name: "PU",
      duration: "2017 - 2019",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        // "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development."
      ],
      website_link: "https://www.pu.edu.pk/",
    },
    {
      title: "Superior Group of collages, Gujranwala",
      subtitle: "Intermediate (ICS)",
      logo_path: "superior-logo.png",
      alt_name: "Superior",
      duration: "2015 - 2017",
      descriptions: [
        "⚡ I have studied basic Computer Science like VB, C++ etc.",
        // "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development."
      ],
      website_link: "https://www.superiorcolleges.edu.pk/gujranwala/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "IBM Full Stack Software Developer",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/cbcd30865e98e2e45161a6ace19d3558",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Application Development using Microservices and Serverless",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/4fa1b8d2f654495a0b692b65d9964ad5",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Introduction to Cloud Computing",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/438a8e16af4786782c8a739aef79e999",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Introduction to Containers w/ Docker, Kubernetes & OpenShift",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/cfa7b88b913e4a8446b9dc706c0802b0",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Django Application Development with SQL and Databases",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/47d8c39642888094ad458b5e44a3c9f3",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Developing AI Applications with Python and Flask",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/f4ce59c0d68e4569056faaf2fdb4c256",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Frontend Developer Capstone",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "https://coursera.org/share/f80912b58e3afcfa49e6116210a2c9da",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "Advanced React",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "https://coursera.org/share/877acd7eaf9dd532a2cb5b103576967e",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "Java Programming: Build a Recommendation System",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "https://coursera.org/share/6af001cafc4b683bb38abdb9e81d0d79",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "React Basics",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "https://coursera.org/share/29c75a387fcaf2f1e2403f73473092b2",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "Programming with JavaScript",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "https://coursera.org/share/cb44f1ee2db3f50b83a56cbae15fcc74",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "HTML and CSS in depth",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "https://coursera.org/share/667de02731a480b76b5300c6612d174d",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "Java Programming: Principles of Software Design",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "https://coursera.org/share/f4e9af47fbb24381e04031f3cc8cfd9f",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "Java Programming: Solving Problems with Software",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "https://coursera.org/share/36411fcea7ea4fbb5c613ef4911f4668",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "Programming Foundations with JavaScript, HTML and CSS",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "https://coursera.org/share/0269c76c33997304d1842d4eef16815b",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "Android Application Development - II",
      subtitle: "- Dr. Adam Porter",
      logo_path: "maryland_logo.svg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/GN48B7W9TU59",
      alt_name: "Stanford University",
      color_code: "#e11a2b",
    },
    {
      title: "Android Application Development - I",
      subtitle: "- Dr. Adam Porter",
      logo_path: "maryland_logo.svg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/2H59Z22DDSU8",
      alt_name: "Stanford University",
      color_code: "#e11a2b",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Christian Hur",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/97WF8EZ4Y2YD",
      alt_name: "Coursera",
      color_code: "#0056d2",
    },
    {
      title: "ML and AI in GCP",
      subtitle: "- GCP Training",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://www.cloudskillsboost.google/public_profiles/345a17d9-689f-4154-a3d3-c0396c98b3bc/badges/2862832",
      alt_name: "GCP",
      color_code: "#2fa9508a",
    },
    {
      title: "Foundational Infrastructure in GCP",
      subtitle: "- GCP Training",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://www.cloudskillsboost.google/public_profiles/345a17d9-689f-4154-a3d3-c0396c98b3bc/badges/2653409",
      alt_name: "GCP",
      color_code: "#4087f08a",
    },
    {
      title: "Networking & Security in GCP",
      subtitle: "- GCP Training",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://www.cloudskillsboost.google/public_profiles/345a17d9-689f-4154-a3d3-c0396c98b3bc/badges/2510430",
      alt_name: "GCP",
      color_code: "#eb40308a",
    },
    {
      title: "Cloud Computing Fundamentals in GCP",
      subtitle: "- GCP Training",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://www.cloudskillsboost.google/public_profiles/345a17d9-689f-4154-a3d3-c0396c98b3bc/badges/2469792",
      alt_name: "GCP",
      color_code: "#fabd008a",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Intership",
  description:
    "I've over 2 years of experience as a MERN Stack Developer. I've worked on building products for multiple stakeholders in Ecommerence, Video Calling, Streaming and Gaming.",
  header_image_path: "experience.svg",
  sections: {
    title: "Work Experience",
    experiences: [
      {
        title: "MERN Stack Developer",
        company: "HyBreathe",
        company_url: "https://ottonomy.io/",
        logo_path: "hybreathe-logo.png",
        alt_name: "ottonomy-logo",
        duration: "(Jan, 2023 - Present)",
        location: "Gujranwala, Pakistan (On-Site)",
        description: "<li>Understanding the flow of projects and make paper work with excellent logic.</li><br><li>Write code and tests, build prototypes, resolve issues, and profile and analyze bottlenecks.</li><br><li>ntegrate frontend and backend components to create seamless user experiences.</li><br><li>Engage in daily client meetings to enhance software reliability and ensure seamless project progression.</li><br><li>Lead deployment and continuous integration processes utilizing AWS, Vercel, Heroku etc. pipelines to ensure seamless delivery and scalability of products.</li>",
        color: "#e94c3d",
      },
      {
        title: "Trainee Backend Developer (JavaScript)",
        company: "ID LOGIX (Pvt) Ltd",
        company_url: "https://idlogixtech.com/",
        logo_path: "id-logix-logo.png",
        alt_name: "id-logix-logo",
        duration: "(Oct, 2022 - Jan, 2023)",
        location: "Lahore, Pakistan (on-Site)",
        description: "<li>Understanding core concepts and folow of JavaScript with the help of latest documentation.</li><br><li>Build the professional frontend design in HTML, CSS and main in JavaScript to polish JavaScript knowledge.</li><br><li>Understanding the Backend techniques in Node Js and ingreating the frontend with Node Js.</li><br><li>Find workable solutions to problems and disputes that arise within the project team.</li>",
        color: "#e94c3d",
      }
    ],
  },
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create MERN Stack Projects. Below are some of my projects.",
  avatar_image_path: "projects_image.svg",
};

const projects = {
  data: [
    {
      id: "project-0",
      name: "Codegames",
      url: "https://codegames-gg-two.vercel.app/",
      repoUrl: "https://github.com/kabeer-ka-ahmed/codegames",
      description:
        "Codegames is a full stack Gaming web application that allows you to purchase different categories of games, gift cards and Topups. You can apply filters accordingly and find your favourite games. You can pay with debit/credit cards and in just few click your game will be delivered throw Gmail.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Redux",
          iconifyClass: "logos:redux",
        },
        {
          name: "Nodejs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "Express",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "MUI",
          iconComponent: 'mui-logo.png',
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Stripe",
          iconifyClass: "logos:stripe",
        },
        // {
        //   name: "Tailwind",
        //   iconifyClass: "logos:mui",
        // },
        {
          name: "AWS",
          iconifyClass: "logos:aws",
        },
        {
          name: "Vercel",
          iconifyClass: "logos:vercel",
        },
      ],
    },
    {
      id: "project-1",
      name: "Help So Easy",
      url: "https://staging.helpsoeasy.com/",
      repoUrl: "https://github.com/kabeer-ka-ahmed/Help-So-Easy",
      description:
        "Help So Easy is a full stack video calling web application that allows you to get solutions of your problems from Experts online. It has wide categories of Sellers on the menu like Doctor, Teacher, Plumber etc.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Redux",
          iconifyClass: "logos:redux",
        },
        {
          name: "Node",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "Express",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "MUI",
          iconComponent: 'mui-logo.png',
        },
        {
          name: "MYSQL",
          iconifyClass: "logos:mysql",
        },
        {
          name: "Stripe",
          iconifyClass: "logos:stripe",
        },
        {
          name: "AWS",
          iconifyClass: "logos:aws",
        },
      ],
    },
    {
      id: "project-2",
      name: "Get Safe Now",
      url: "https://get-safe-now.vercel.app/",
      repoUrl: "https://github.com/kabeer-ka-ahmed/Get-Safe-Now",
      description:
        "Get Safe Now(GSN) is a full stack video calling web application that allows you to make friendily video calls with your connections.",
        languages: [
          {
            name: "React",
            iconifyClass: "logos:react",
          },
          {
            name: "Redux",
            iconifyClass: "logos:redux",
          },
          {
            name: "Node",
            iconifyClass: "logos:nodejs",
          },
          {
            name: "Express",
            iconifyClass: "simple-icons:express",
          },
          {
            name: "MUI",
            iconComponent: 'mui-logo.png',
          },
          {
            name: "MYSQL",
            iconifyClass: "logos:mysql",
          },
          {
            name: "Stripe",
            iconifyClass: "logos:stripe",
          },
          {
            name: "AWS",
            iconifyClass: "logos:aws",
          },
        ],
    },
    // {
    //   id: "project-3",
    //   name: "Countdown Timer",
    //   url: "https://countdown-timer-sumit-sharma-02.vercel.app/",
    //   repoUrl: "https://github.com/sumit-sharma-02/countdown-timer",
    //   description: "A Simple React App for countdown to new year using hooks.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "React",
    //       iconifyClass: "logos-react",
    //     },
    //   ],
    // },
    // {
    //   id: "project-4",
    //   name: "Portfolio",
    //   url: "",
    //   repoUrl: "https://github.com/sumit-sharma-02/sumit-portfolio",
    //   description: "You are watching it right now 😉.",
    //   languages: [
    //     {
    //       name: "React",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "React Reveal",
    //       iconifyClass: "simple-icons:scrollreveal",
    //     },
    //     {
    //       name: "Styled Components",
    //       iconifyClass: "vscode-icons:file-type-styled",
    //     },
    //   ],
    // },
    // {
    //   id: "project-5",
    //   name: "SpaceX Capsules",
    //   url: "https://spacex-capsules.vercel.app/",
    //   repoUrl: "https://github.com/sumit-sharma-02/spacex-capsules",
    //   description:
    //     "A React application which shows you the filtered spaceX capsules data.",
    //   languages: [
    //     {
    //       name: "React",
    //       iconifyClass: "logos:react",
    //     },
    //     {
    //       name: "Redux",
    //       iconifyClass: "logos:redux",
    //     },
    //     {
    //       name: "Tailwind",
    //       iconifyClass: "vscode-icons:file-type-tailwind",
    //     },
    //   ],
    // },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "MyPortfolioImage2.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
